import React, { createContext, useContext, useEffect, useState } from 'react';
import { authApi } from '../api/endpoints';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const stored = localStorage.getItem('kiana_crm_user');
    if (stored) {
      try { setUser(JSON.parse(stored)); }
      catch (e) {
        console.error('Corrupt auth data in storage, clearing session', e);
        localStorage.removeItem('kiana_crm_user');
      }
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    if (!email || !password) return { ok: false, error: 'Email and password are required' };
    try {
      const data = await authApi.login(email, password);
      const userObj = { ...data.user, token: data.token };
      localStorage.setItem('kiana_crm_user', JSON.stringify(userObj));
      setUser(userObj);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: e?.response?.data?.detail || 'Login failed' };
    }
  };

  const refreshMe = async () => {
    try {
      const fresh = await authApi.me();
      const merged = { ...user, ...fresh, token: user?.token };
      localStorage.setItem('kiana_crm_user', JSON.stringify(merged));
      setUser(merged);
    } catch (e) { console.error('Failed to refresh user profile', e); }
  };

  const logout = () => {
    localStorage.removeItem('kiana_crm_user');
    setUser(null);
  };

  const hasPermission = (module, action) => {
    if (!user) return false;
    const perms = user.permissions || {};
    return Array.isArray(perms[module]) && perms[module].includes(action);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, hasPermission, refreshMe }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
